import { render } from "./NotFound.vue?vue&type=template&id=7dd6fe07&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=7dd6fe07&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd6fe07"]])

export default __exports__